import { de, Texts } from "./de";

export const en: Texts = {
	general: {
		name: de.general.name,
		locales: de.general.locales,
	},
	navigation: {
		profile: "Profile",
		company: "Company",
		objects: "Objects",
		contact: "Contact",
	},
	hero: {
		contact: "To Contact",
		slogan: "nachhaltig, unabhängig, partnerschaftlich",
	},
	home: {
		hero: {
			title: "Berlin",
		},
	},
	profile: {
		title: "Ankaufsprofil",
		description: "...",
		list: {
			assetClasses: {
				title: "Assetklassen",
				values: [
					"- Büro",
					"- Logistik, Light Industrial, Urban Logistics",
					"- Einzelhandel (Fachmarktzentren, Lebensmitteleinzelhandel)",
					"- Hotel, Boardinghäuser",
					"- Wohn- und Geschäftshäuser",
				],
			},
			location: {
				title: "Standorte",
				values: [
					"- Deutschlandweit Städte ab 100.000 Einwohner",
					"- Für Logistik: Etablierte Logistikstandorte in Metropolregionen",
				],
			},
			riskClassAndProperties: {
				title: "Risikoklassen & Eigenschaften",
				values: [
					"Core Plus - Value Add:",
					"- Voll vermietet bis 100% Leerstand",
					"- Sehr gute bis mittlere Objektqualität",
					"- Langfristiges Wertschöpfungs- und Entwicklungspotential",
					"- Refurbishments",
				],
			},
			volume: {
				title: "VOLUMEN",
				values: ["ab EUR 3 Mio."],
			},
		},
		hint: {
			title: "...",
			text: "...",
		},
	},
	objects: {
		title: "Objects",
		elements: [
			{
				title: "Berlin - Leerstehendes Hotel in Berliner Bestlage, 2021",
				description:
					"Asset Management Strategie: Bestandsrevitalisierung und Neuvermietung\n" +
					"Risikoprofil: Value Add\n" +
					"Mietfläche: 1.000",
			},
			{
				title:
					"Bonn - Gemischt-genutztes Gebäudeensembles mit Einzelhandelschwerpunkt in zentrumsnahem Gewerbegebiet, 2021",
				description:
					"Asset Management Strategie: Optimierung der bestehenden Mieterstrukturen mit aktivem Asset Management-Ansatz vor dem Hintergrund langfristiger Entwicklungsperspektiven am Standort\n" +
					"Risikoprofil: Value Add\n" +
					"Mietfläche: 10.400",
			},
			{
				title:
					"Hamm - Fachmarktzentrum mit Baumarkt als Ankermieter in stark nachgefragtem Gewerbegebiet im Westen Hamms, 2021",
				description:
					"Asset Management Strategie: Optimierung & Verlängerung der bestehenden Mietverhältnisse mit aktivem Asset Management-Ansatz\n" +
					"Risikoprofil: Value Add \n" +
					"Mietfläche: 12.300",
			},
		],
	},
	company: {
		title: "Company",
		description: [],
	},
	contact: {
		phone: "+49 40 809081462",
		address: ["Rutschbahn 39", "20146 Hamburg"],
		email: "investment@aquila-real.de",
	},
	disclaimer: {
		hero: {
			title: "Disclaimer",
		},
		paragraphs: [
			{ type: "text", text: "..." },
			{ type: "headline", text: "...2" },
			{ type: "text", text: "...3" },
		],
	},
	terms: {
		hero: {
			title: "Terms & Conditions",
		},
		paragraphs: [
			{ type: "text", text: "..." },
			{ type: "headline", text: "...2" },
			{ type: "text", text: "...3" },
		],
	},
	privacy: {
		hero: {
			title: "Privacy Policy",
		},
		paragraphs: [
			{ type: "text", text: "..." },
			{ type: "headline", text: "...2" },
			{ type: "text", text: "...3" },
		],
	},
	imprint: {
		hero: {
			title: "Imprint",
		},
		paragraphs: [
			{ type: "text", text: "..." },
			{ type: "headline", text: "...2" },
			{ type: "text", text: "...3" },
		],
	},
};
